import { ConversationFlowAuditLogEntry } from 'apis/auditLogs';

type RoutedThroughCloseProps = {
  node: ConversationFlowAuditLogEntry<
    'EMAIL_CLOSE_NODE_VISITED' | 'MESSENGER_CLOSE_NODE_VISITED'
  >;
};

export function RoutedThroughClose(_: RoutedThroughCloseProps): JSX.Element {
  return <>Close conversation</>;
}
